import { Injectable } from '@angular/core';
import { AccountStore, type OlChangePasswordPayload } from '@ol/kit';
import { Observable, switchMap } from 'rxjs';

/**
 * Hub override of the kit `AccountStore`: a successful self password change must end the
 * current session (legacy `change-password-modal` behavior). The backend sets a per-user
 * token-invalidation cutoff on password change, so the current token dies server-side
 * within one revocation-refresh interval anyway — logging out immediately turns that
 * from surprise 401s into a clean re-login. Logout goes through the kit's own
 * `OL_ACCOUNT_AUTH` seam (the hub adapter revokes the token before redirecting).
 */
@Injectable()
export class HubAccountStore extends AccountStore {
  override changePassword(payload: OlChangePasswordPayload): Observable<void> {
    return super.changePassword(payload).pipe(switchMap(() => this.logout()));
  }
}
